import { Component, Input } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';
import { ViewManager, PdfTableColumn } from 'src/app/board/pages/admin/admin-components/custom-views-config/view-builder/models/view-builder.models';

@Component({
  selector: 'bhub-pdf-table-cell',
  standalone: false,
  templateUrl: './pdf-table-cell.component.html',
  styleUrls: ['./pdf-table-cell.component.scss']
})
export class PdfTableCellComponent extends BaseCellComponent {
  @Input() viewManager: ViewManager | null = null;

  columns: PdfTableColumn[] = [];
  showHeader: boolean = true;
  headerFontSize: number = 12;
  headerFontWeight: string = 'bold';
  rowFontSize: number = 10;
  tableData: any[] = [];

  protected initializeCell(): void {
    this.updateDisplayProperties();
  }

  protected onCellOrDataChange(): void {
    this.updateDisplayProperties();
  }

  protected onCellUpdate(): void {
    this.updateDisplayProperties();
  }

  protected onDataSet(data: any): void {
    this.updateDisplayProperties();
  }

  reloadData(): void {
    this.updateDisplayProperties();
  }

  private updateDisplayProperties(): void {
    if (!this.cell) return;

    this.columns = this.getConfigValue('pdfTableColumns', []);
    this.showHeader = this.getConfigValue('pdfShowHeader', true);
    this.headerFontSize = this.getConfigValue('pdfHeaderFontSize', 12);
    this.headerFontWeight = this.getConfigValue('pdfHeaderFontWeight', 'bold');
    this.rowFontSize = this.getConfigValue('pdfRowFontSize', 10);

    // Get table data from context
    const contextVariable = this.getDataBindingValue('contextVariable');

    if (contextVariable && this.viewManager?.contextData) {
      const dataObject = this.viewManager.contextData[contextVariable];
      if (Array.isArray(dataObject)) {
        this.tableData = dataObject;
      } else if (dataObject) {
        // Single object - wrap in array
        this.tableData = [dataObject];
      } else {
        this.tableData = [];
      }
    } else {
      this.tableData = [];
    }
  }

  getCellValue(row: any, column: PdfTableColumn): string {
    const value = row[column.fieldName];
    if (value === null || value === undefined) {
      return '';
    }

    if (column.format === 'currency' && typeof value === 'number') {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
    }

    if (column.format === 'date') {
      return new Date(value).toLocaleDateString();
    }

    if (column.format === 'number' && typeof value === 'number') {
      return new Intl.NumberFormat('en-US').format(value);
    }

    return String(value);
  }

  hasData(): boolean {
    return this.columns.length > 0;
  }
}
